import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AuthFrame } from "./AuthFrame";
import { useSession } from "../../services/SessionContext";

export function VerifyEmailPage() {
  const { resendVerificationCode, verifyEmail } = useSession();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate();

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError("");
    setMessage("");
    setIsSubmitting(true);
    try {
      await verifyEmail(code);
      navigate("/app/setup");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Email verification failed.");
    } finally {
      setIsSubmitting(false);
    }
  }

  async function resendCode() {
    setError("");
    setMessage("");
    setIsResending(true);
    try {
      await resendVerificationCode();
      setMessage("A new verification code was sent.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not resend the verification code.");
    } finally {
      setIsResending(false);
    }
  }

  return (
    <AuthFrame title="Verify email" subtitle="Confirm your email before creating a workspace.">
      <form className="space-y-4" onSubmit={submit}>
        <div className="space-y-2">
          <Label htmlFor="code">Verification code</Label>
          <Input
            id="code"
            inputMode="numeric"
            placeholder="Enter the code from email"
            required
            value={code}
            onChange={(event) => setCode(event.target.value)}
          />
        </div>
        {error ? <p className="text-sm font-medium text-red-700">{error}</p> : null}
        {message ? <p className="text-sm font-medium text-field-700">{message}</p> : null}
        <Button className="w-full" type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Verifying email" : "Verify email"}
        </Button>
        <Button className="w-full" type="button" variant="secondary" disabled={isResending} onClick={resendCode}>
          {isResending ? "Sending code" : "Resend code"}
        </Button>
      </form>
    </AuthFrame>
  );
}
